import React, { useState, useEffect, useContext } from 'react';
import { UserContext } from '../../../Context/UserContextProvider';
import axios from "../../../../axios/index"

import 'react-toastify/dist/ReactToastify.css';

// Styles
import styles from "../../StaffManagment/StaffManagment.module.css";

// Images
import deleteIcon from "../../../../assets/img/DashboardICons/DeleteIcon_Rounded.svg";

export default function NewFilesConsultantSelect({ state, setFileData, fileData, editedData }) {
    const { userToken } = useContext(UserContext);
    const [consultantsList, setConsultantsList] = useState()

    const handleClick = (id) => {
        const itemSelected = consultantsList?.filter((item) => id === item.id);
        const found = fileData.fileConsultant.find(item => item.id == itemSelected[0].id)
        if (found === undefined) {
            setFileData((prev) => {
                return { ...prev, fileConsultant: [itemSelected[0]], openedAccordion: "1" };
            });
        }
    };

    const deleteHandler = (e) => {
        const itemFiltered = fileData.fileConsultant.filter((item) => item.id != e.target.id);
        setFileData((prev) => {
            return { ...prev, fileConsultant: itemFiltered, openedAccordion: "1" };
        });
    }

    useEffect(() => {
        const getData = async () => {
            const getApiData = await axios.get(
                "Consultant?Take=1000000000",
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );
            const data = getApiData.data.data.data.filter((item) => item.userId !== state.userId)
            setConsultantsList(data)
            if (editedData) {
                const findSelectedItem = data.find((item) => item.userId === fileData.fileConsultantID);
                setFileData((prev) => {
                    return { ...prev, fileConsultant: [findSelectedItem] };
                });
            }
        }
        getData();
    }, [userToken, state, editedData])

    const topItems = fileData?.fileConsultant?.map((item) => {
        return (
            <>
                {fileData?.fileConsultant != "" &&
                    <div
                        className={`d-flex align-items-center px-2 my-2 mx-2 ${styles.invited_people_container}`}
                        key={item.id}
                    >
                        <div className={styles.added_person_text}>
                            <img
                                className={`ms-2 ${styles.user_profile}`}
                                src={`https://backdev.azrmelk.com${item.imageUrl}`}
                                alt="img"
                            />
                            {item.name + " " + item.family}
                        </div>
                        <img
                            id={item.id}
                            onClick={deleteHandler}
                            className="me-3 pointer"
                            src={deleteIcon}
                            alt="icon"
                        />
                    </div>
                }

            </>


        );
    });

    const bottomItems = consultantsList?.map((item) => {
        return (
            <div
                key={item.id}
                className={`d-flex align-items-center px-3 my-2 mx-2 ${styles.invited_people_container}`}
            >
                <div
                    onClick={() => handleClick(item.id)}
                    id={item.id}
                    className={`pointer ${styles.added_person_text}`}
                    style={{ cursor: "default" }}
                >
                    <img
                        className={`ms-2 ${styles.user_profile}`}
                        src={`https://backdev.azrmelk.com${item.imageUrl}`}
                        alt="img"
                    />
                    {item.name + " " + item.family}
                </div>
            </div>
        );
    });

    return (
        <>

            <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-2 mx-2" dir="rtl">
                <div className="mt-1 w-100 text-center">
                    <div className={`w-100 text-end m-3 ${styles.title_bold}`}>
                        انتخاب مشاور
                    </div>
                    <div className={`w-100 d-flex align-items-start justify-content-start flex-column mt-2 pt-3 pe-4 ${styles.consultantslist_container}`}>
                        <div className={`mb-3 ${styles.input_top_title}`}>
                            مشاور انتخاب شده
                        </div>

                        <div className="w-100 d-flex align-items-center justify-content-start flex-wrap mb-3">
                            {
                                fileData.fileConsultant?.length > 0 && fileData.fileConsultant != undefined
                                    ? (
                                        <div
                                            className={`d-flex align-items-center justify-content-start flex-wrap my-2 py-2 ${styles.added_people_conatiner}`}
                                        >
                                            {topItems}
                                        </div>
                                    )
                                    : null
                            }
                        </div>
                    </div>

                    <div
                        className={`w-100 d-flex align-items-start justify-content-start flex-column mt-2 pt-3 pe-4 ${styles.consultantslist_container}`}
                    >
                        <div className={`mb-3 ${styles.input_top_title}`}>
                            لیست مشاوران
                        </div>

                        <div className="w-100 d-flex align-items-center justify-content-start flex-wrap mb-3">
                            {bottomItems}
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}
